import { AxiosService } from './axios'

export async function getLabel(path, language) {
    return await AxiosService.sendGet(path, language)
}

export async function getConfig(path, language) {
    return await AxiosService.sendGet(path, language)
}

export async function getMenu(path, language) {
    return await AxiosService.sendGet(path, language)
}

export async function getContent(path, language, params) {
    return await AxiosService.sendGet(path, language, params)
}

export async function getPartner(path) {
    return await AxiosService.sendGet(path)
}

export async function getPageContent(path, language) {
    return await AxiosService.sendGet(path, language)
}

export async function submitForm(path, payload) {
    return await AxiosService.sendPost(path, payload)
}

export const AppService = {
    getLabel,
    getConfig,
    getMenu,
    getContent,
    getPartner,
    getPageContent,
    submitForm
}
